export default "__VITE_ASSET__CYzHUrvl__"